<template>
  <div>
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-3">Excel File Upload</h5>
            <div class="d-flex align-items-center mb-3">
              <i class="bx bxs-file text-primary fs-3"></i>
              <h5 class="text-primary m-0">How to bulk create adjustment?</h5>
            </div>
            <div class="mb-3 col-sm-12">
              <b-form-file class="form-control mb-1" :class="{ 'is-invalid': !$v.file.required && submitted }" type="file" v-model="file" @change="onFileChange" plain />
              <div v-if="submitted && $v.file.$error" class="text-danger">
                <span v-if="!$v.file.required">This value is required.</span>
              </div>
              <div class="d-flex align-items-center">
                <label class="form-label fs-12">File extension: CSV, xlsx, excel format limit size: 3mb</label>
                <b-link class="ms-auto form-label fs-12" @click="$refs.exportExcelBtn.click()">Download Free Template</b-link>
              </div>

            </div>

            <div class="px-3 py-1">
              <p><span class="text-secondary">Step 1</span> - Download Free Template and fill-out the field needed.</p>
              <p><span class="text-secondary">Step 2</span> - Click choose file you already fill-out.</p>
              <p><span class="text-secondary">Step 3</span> - Click Approval.</p>
            </div>
            <p>
              <span class="text-success">Note:</span> Approval process in bulk upload if with even just one wallet adjustment in approval
              will be including finance.
            </p>
            <div class="d-flex align-items-center">
              <div class="ms-auto">
                <button class="btn btn-primary me-3" style="width: 170px" @click="submitAdjustment()" :disabled="isApprovalDisable">Approval</button>
                <router-link :to="{ name: 'Adjustment Transaction Dashboard' }" class="tc-white">
                  <b-button variant="light" class="w-sm" type="button" style="width: 170px">Cancel</b-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template>
      <section class="no-height">
        <xlsx-workbook>
          <xlsx-sheet :collection="sheet.data" v-for="sheet in sheets" :key="sheet.name" :sheet-name="sheet.name" />
          <xlsx-download filename="Adjustment-Transaction-Template.csv">
            <button ref="exportExcelBtn">Download</button>
          </xlsx-download>
        </xlsx-workbook>
      </section>
    </template>
    <template>
      <section class="no-height">
        <xlsx-read :file="file">
          <xlsx-json @parsed="parsed">
            <template #default="{collection}">
              <div>
                {{ collection }}
              </div>
            </template>
          </xlsx-json>
        </xlsx-read>
      </section>
    </template>
  </div>
</template>

<script>
import { layoutMethods, peddlrWalletMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import { XlsxWorkbook, XlsxSheet, XlsxDownload, XlsxRead, XlsxJson } from "vue-xlsx/dist/vue-xlsx.es";
// import * as XLSX from "xlsx";
import shortid from "shortid";

export default {
  page: {
    title: "Adjustment Transaction Batch Upload",
  },
  validations: {
    file: { required },
  },
  data() {
    return {
      file: null,
      s3_url: null,
      adjustmentFile: {
        filename: null,
        type: null,
        base64: null,
      },
      massUploadData: null,
      sheets: [
        {
          name: "Sheet1",
          data: [
            {
              "Adjustment Type": "Value should be Reporting Only or Wallet Adjustment only", 
              "Reason": "Should be 40 characters only",
              "Adjustment Direction": "Value should be Addition or Deduction only",
              "Amount": null,
              "Account Number": null,
            },
          ],
        },
      ],
      submitted: false,
      parsedFile: [],
      isApprovalDisable: false,
    };
  },
  components: {
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    XlsxRead,
    XlsxJson
  },
  computed: {},
  methods: {
    ...layoutMethods,
    ...peddlrWalletMethods,
    onFileChange(e) {
      const reader = new FileReader();
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.adjustmentFile = {
          filename: null,
          type: null,
          base64: null,
        };
        return;
      }

      reader.onloadend = () => {
        var base64Data = reader.result;
        this.adjustmentFile.type = base64Data.split(";")[0].split("/")[1];
        // console.log(">>> base64Data:",reader);
        // if(this.compareStr(this.adjustmentFile.type,["jpeg","png","svg","jpg"])){
        //   this.adjustmentFile.base64 = new Buffer.from(base64Data.replace(/^data:image\/[a-zA-Z+]+;base64,/, ''), 'base64');
        // }
        if (this.compareStr(this.adjustmentFile.type, ["csv", "xlsx"])) {
          this.adjustmentFile.base64 = new Buffer.from(base64Data.replace(/^data:text\/[a-zA-Z+]+;base64,/, ""), "base64");
        }
        if (this.compareStr(this.adjustmentFile.type, ["vnd.openxmlformats-officedocument.spreadsheetml.sheet"])) {
          this.adjustmentFile.base64 = new Buffer.from(
            base64Data.replace(/^data:application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,/, ""),
            "base64"
          );
        }
        // console.log("this.adjustmentFile.base64",this.adjustmentFile.base64);
        if (this.adjustmentFile.type == "svg+xml") {
          this.adjustmentFile.type = "svg";
        }
        this.adjustmentFile.filename = `${shortid.generate()}.${this.adjustmentFile.type}`;
        // console.log(this.adjustmentFile);
        if (this.compareStr(this.adjustmentFile.type, ["csv", "xlsx", "vnd.openxmlformats-officedocument.spreadsheetml.sheet"]) === false) {
          //"jpeg","png","svg","jpg",
          this.adjustmentFile = {
            filename: null,
            type: null,
            base64: null,
          };
          Swal.fire("Invalid supporting document!", `CSV or excel file is required`, "error");
        }
      };
      reader.readAsDataURL(files[0]);
    },
    compareStr(data, arr_similar){// case insensitive string comparison
      for(var i = 0; i < arr_similar.length; i++){
          var areEqual = data.toUpperCase() === arr_similar[i].toUpperCase();
            if(areEqual){
              return areEqual;
            }
        }
        return false;
    },
    parsed(event) {
      this.parsedFile = event;

      // check if there are invalid values
      if (this.parsedFile.some(i => (i["Adjustment Type"].toLowerCase() != "reporting only" && i["Adjustment Type"].toLowerCase() != "wallet adjustment") 
            || (i["Adjustment Direction"].toLowerCase() != "addition" && i["Adjustment Direction"].toLowerCase() != "deduction") )) {
        console.log("INVALID VALUES");
        this.isApprovalDisable = true;
        Swal.fire(
          "Invalid Inputs!", 
          "Please check your inputs for Adjustment Type and Adjustment Direction", 
          "error"
        );
      } else {
        this.isApprovalDisable = false;
      }
    },
    async submitAdjustment() {
      // alert("Form submit");
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      Swal.fire({
        title: "Are you sure?",
        text: `You will no longer be able to edit this request.`,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonColor: "#c4297c",
        cancelButtonColor: "#804997",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.uploadFile().then(() => this.submitted = false);
        }
      });
    },
    uploadFile() {
      if (this.adjustmentFile.base64) {
        var adjustmentFile = { ...this.adjustmentFile };

        this.uploadAdjustmentExcelFile(adjustmentFile)
          .then((imageKey) => {
            this.s3_url = imageKey;
            let payload = {
              task: "bulk-process",
              body: {
                key: this.s3_url
              }
            }
            this.invokeBulkProcessFunction(payload)
                .then((res) => {
                  if (res.status == "ok") {
                    Swal.fire("Successfully Uploaded!", `${this.file.name} has been uploaded`, "success");
                    this.$router.push({ name: "Adjustment Transaction Dashboard" });
                  } else {
                    Swal.fire("Upload Failed!", `An error occured while uploading file. Please try again later.`, "danger");
                  }
                })
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        // if ((this.$route.params.id == 0 && this.$route.params.action == "new") || this.$route.params.action == "copy") {
        //   this.create();
        // } else {
        //   this.update();
        // }
      }
    },
  },
  async mounted() {
    this.changeTitle({ title: "Adjustment Transaction Batch Upload" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Kankolek", to: { name: "" } },
        { text: "Adjusment Transaction", to: { name: "Adjustment Transaction Dashboard" } },
        { text: "Bulk Create Adjustment", to: { name: "" } },
      ],
    });
  },
};
</script>

<style scoped>
.no-height {
  height: 0;
  display: none;
}
</style>
